<template>
  <v-app-bar class="pl-4" fixed height="64">
    <v-app-bar-nav-icon @click="showOverlay()">
      <v-badge :value="$store.state.notificationQueue.length > 0" color="blue" overlap>
        <template v-slot:badge>
          <span>{{ $store.state.notificationQueue.length }}</span>
        </template>
        <v-icon large>menu</v-icon>
      </v-badge>
    </v-app-bar-nav-icon>
    <v-toolbar-title id="toolbar-logo">
      <router-link v-slot="{ navigate }" to="/">
        <div id="project-logo" @click="navigate">
          <img class="pt-2" src="@/assets/inther_bow_small.png"/>
          <span id="logo-text">CuS</span>
        </div>
      </router-link>
    </v-toolbar-title>
    <v-spacer/>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on">
          <v-icon class="mr-2">mdi-translate</v-icon>
          {{ currentLanguage }}
          <v-icon>mdi-menu-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(lang, index) in languages" :key="index" @click="changeLanguage(lang)">
          <v-list-item-title>{{ getNativeLanguageName(lang) }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import {EventBus} from "@/lib/event-bus";
import ISO6391 from "iso-639-1";
import {EVENTBUS_TOPICS} from '@/lib/constants';

export default {
  name: "application-toolbar",
  components: {},
  data() {
    return {
      languages: Object.keys(this.$i18n.messages),
    };
  },
  computed: {
    currentLanguage() {
      return this.getNativeLanguageName(this.$i18n.locale);
    }
  },
  methods: {
    showOverlay() {
      EventBus.$emit(EVENTBUS_TOPICS.SHOW_OVERLAY, true);
    },
    changeLanguage(newLang) {
      if (localStorage.getItem("lang") !== newLang) {
        localStorage.setItem("lang", newLang);
        this.$i18n.locale = newLang;
        EventBus.$emit(EVENTBUS_TOPICS.LANGUAGE_CHANGE);
      }
    },
    getNativeLanguageName(locale) {
      return ISO6391.getNativeName(locale);
    }
  },
};
</script>

<style scoped>
#toolbar-logo {
  position: relative;
}

#toolbar-logo #logo-text {
  position: absolute;
  font-size: 20pt;
  left: 18px;
  top: 34px;
}

#project-logo {
  cursor: pointer;
}
</style>
